import { initializeApp } from "firebase/app";

const firebaseConfig = {
  apiKey: "AIzaSyB0viRaTCz-9N1kakJWQgjs23SwhlppLQA",
  authDomain: "react-ecommerce-18862.firebaseapp.com",
  projectId: "react-ecommerce-18862",
  storageBucket: "react-ecommerce-18862.appspot.com",
  messagingSenderId: "68560470475",
  appId: "1:68560470475:web:61937bff2f7c1beb9e364e",
  measurementId: "G-F50N3PPPFJ"
};

export const app = initializeApp(firebaseConfig);

